import React from "react";
import DesignView from "./components/map-view/DesignView";

const MapView = () => {
  return (
    <div>
      <DesignView />
    </div>
  );
};

export default MapView;
